/* Code based on the Playshorts documentation : https://playshorts.gitbook.io/playshorts-documentation-technique/add-to-cart/integration-shopify */
/* Edited to handle cart drawer refresh and opening */

// Add to cart function
const addToCart = async (variantId) => {
  const formData = {
    id: variantId,
  };

  await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  });

  // Get cart state
  await fetch(window.Shopify.routes.root + "cart.js");
};

// Add to cart listener
document.addEventListener("PLAYSHORTS_ADD_TO_CART", async (event) => {
  const { variantId } = event.detail;
  let success = false;

  try {
    await addToCart(variantId);
    success = true;
  } catch (error) {
    console.error(error);
  }

  document.dispatchEvent(
    new CustomEvent("PLAYSHORTS_ADD_TO_CART_RESPONSE", {
      detail: { variantId, success }
    })
  );
});

document.addEventListener("PLAYSHORTS_SHOW_CART", () => {
  document.querySelector('.skallup-player-close-product').click();

  setTimeout(() => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }, 200);
});